export default __webpack_public_path__ + "images/4167872942235b34723bd7f9167e79f8-EE_SlideDeckBOOK1024_12.png";